import { productFilters, booleanFilters, filterPropMap } from "./common"
import { getCollectionUrl } from "@utils/urls"
import _ from "lodash"

export const getBreadcrumbs = (categories) => {
  let currentSlug
  return categories.map(({ name, slug }) => {
    currentSlug = currentSlug ? currentSlug + "/" + slug : slug
    return { name, slug: getCollectionUrl(currentSlug) }
  })
}

export const getFlattenedProducts = (products) => {
  return _.flatten(
    products.map((product) =>
      product.variants?.length > 0
        ? _.flatten([
            product,
            ...product.variants.map((variant) => ({
              ..._.omit(product, "variants"),
              ...variant,
            })),
          ])
        : product
    )
  )
}

export const getFilterValues = (flattenedProducts) => {
  const filterValues = _.fromPairs(
    _.map(filterPropMap, (v, k) => {
      const values = _.uniq(
        _.flatten(
          flattenedProducts.map(
            (p) => (v.props && p[v.props]) || (v.prop && p[v.prop])
          )
        )
          .filter((p) => (!!p || p === false) && p !== "0" && p !== 0)
          .sort()
      )

      return [k, values]
    }).filter((kV) => kV[1].length > 0)
  )
  const booleanFilterKeys = Object.keys(filterValues).filter((f) => {
    return booleanFilters.indexOf(f) !== -1
  })

  if (booleanFilterKeys.length > 0) {
    filterValues["Features"] = booleanFilterKeys
  }

  return _.omit(filterValues, booleanFilters)
}

export const formatProduct = (product, placeholderImage) => {
  const flattenedProduct = product.variants
    ? _.flatten([
        product,
        ...product.variants.map((variant) => ({
          ..._.omit(product, "variants"),
          ...variant,
        })),
      ])
    : [product]

  const exterior = _.uniq(
    flattenedProduct
      .map(({ exterior }) => exterior)
      .filter((exterior) => !!exterior)
  )

  const interior = _.uniq(
    _.flatten(
      flattenedProduct
        .map(({ interior }) => interior)
        .filter((interior) => !!interior)
    )
  )

  const color = _.uniq(
    _.flatten(
      flattenedProduct.map(({ color }) => color).filter((color) => !!color)
    )
  )

  const variants: any = []

  if (color.length) {
    variants.push(`${color.length} Color${color.length > 1 ? "s" : ""}`)
  }

  if (interior.length) {
    variants.push(
      `${interior.length} Interior${interior.length > 1 ? "s" : ""}`
    )
  }

  return {
    ..._.pick(product, productFilters),
    type: product._type,
    updatedAt: product._updatedAt,
    releaseDate: product.releaseDate,
    image: product.mainImage || placeholderImage,
    slug: product.slug.current || product.slug,
    name: product.productName,
    model: product.sku,
    price: product.price,
    variants: variants.join(", "),
    series: product.series,
    color,
    exterior,
    interior,
  }
}

export const formatDisplayedCategory = (category) => {
  const regex = /(\(.*?)\)/
  return category.replace(regex, "").trim()
}
